require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./les-programmes-master-2-2-2.json") })
        }
      }, "path---les-programmes-master-2-2-2");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---les-programmes-master-2-2-2!./.cache/json/les-programmes-master-2-2-2.json
// module id = 479
// module chunks = 231608221292675